<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <app-print-button></app-print-button>
    </app-tab-header>
<p>promo works!</p>
